$("#back-to-top").on("click", function (event) {
	event.preventDefault();
	$("html, body").stop(true, true).animate({ scrollTop: 0 }, 250);
});

$(window).on("scroll", function () {
	if ($(window).scrollTop() <= 150) {
		$("#back-to-top").removeClass("hide-back-to-top").addClass("hide-back-to-top");
	} else {
		$("#back-to-top").removeClass("hide-back-to-top");
	}
});
